<app-pharm-header></app-pharm-header>
<div class="transfer-log-container">
  <app-pharm-sidebar></app-pharm-sidebar>

  <div class="main-content">
    <h2>🔄 Transfer Logs</h2>

    <!-- Filters -->
    <div class="filters">
      <input type="text" [(ngModel)]="searchTerm" placeholder="🔍 Search by product, store..." />

      <label>From:</label>
      <input type="date" [(ngModel)]="fromDate" />

      <label>To:</label>
      <input type="date" [(ngModel)]="toDate" />
    </div>

    <!-- Table -->
    <table *ngIf="!loading && getFilteredTransfers().length">
      <thead>
        <tr>
          <th>Product</th>
          <th>From Store</th>
          <th>To Store</th>
          <th>Quantity</th>
          <th>Note</th>
          <th>Transfer Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let t of paginatedTransfers()">
  <td><span class="label">Product:</span> {{ t.stock_name }}</td>
  <td><span class="label">From Store:</span> {{ t.from_store }}</td>
  <td><span class="label">To Store:</span> {{ t.to_store }}</td>
  <td><span class="label">Quantity:</span> {{ t.quantity }}</td>
  <td><span class="label">Note:</span> {{ t.note || '—' }}</td>
  <td><span class="label">Transfer Date:</span> {{ t.transfer_date | date: 'short' }}</td>
</tr>

      </tbody>
    </table>

    <!-- Loading or Empty -->
    <div *ngIf="loading">⏳ Loading transfers...</div>
    <div *ngIf="!loading && !getFilteredTransfers().length">❌ No transfer logs found.</div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="getFilteredTransfers().length > pageSize">
      <button (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">⬅️ Prev</button>
      <span>Page {{ currentPage }}</span>
      <button (click)="currentPage = currentPage + 1" [disabled]="currentPage * pageSize >= getFilteredTransfers().length">Next ➡️</button>
    </div>
  </div>
</div>
